import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

type RingSpinnerProps = {
  height: number;
  width: number;
};

const RingSpinner = styled.div<RingSpinnerProps>`
  display: inline-block;
  position: relative;
  width: ${({ width }) => width || 80}px;
  height: ${({ height }) => height || 80}px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${({ width }) => width * 0.8}px;
    height: ${({ height }) => height * 0.8}px;

    margin: ${({ width }) => width * 0.1}px;
    border: ${({ width }) => width * 0.1}px solid rgba(239, 239, 239, 0.76);
    border-radius: 50%;
    animation: ${spin} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: rgba(239, 239, 239, 0.76) transparent transparent transparent;
  }

  div:nth-of-type(1) {
    animation-delay: -0.45s;
  }

  div:nth-of-type(2) {
    animation-delay: -0.3s;
  }

  div:nth-of-type(3) {
    animation-delay: -0.15s;
  }

  div:nth-of-type(4) {
    animation-delay: 0s;
  }
`;

type RingProps = {
  height: number;
  width: number;
};

export const Ring = ({ height, width }: RingProps) => (
  <RingSpinner height={height} width={width}>
    <div />
    <div />
    <div />
    <div />
  </RingSpinner>
);
